import clsx from 'clsx'
import Link from 'next/link'
import { intl } from 'src/i18n'
import { formatPeriodAgo } from 'src/utils/time'
import styles from './styles.module.scss'

export const RelatedNews = ({ coinData }) => {
  return (
    <>
      {coinData.relatedNews && coinData.relatedNews.length > 0 && (
        <div className={styles.relatedNews}>
          {coinData.relatedNews.map(item => (
            <Link
              href={item.link}
              key={item.title}
              prefetch={false}
              legacyBehavior
            >
              <a
                className={clsx(styles.newsItem, {
                  [styles.featured]: item?.featured,
                })}
                rel='noopener nofollow noreferrer'
                target='_blank'
              >
                <div className={styles.newsItemHeader}>
                  {item?.featured && (
                    <div className={styles.neaturedLabel}>
                      {intl.t('coinDetails.relatedNews.feature')}
                    </div>
                  )}
                  {formatPeriodAgo(item.age)} • {item.src}
                </div>
                <div className={styles.newsItemTitle}>{item.title}</div>
                <div className={styles.newsItemText}>
                  {item.text.replace(/&nbsp;/g, '')}
                </div>
              </a>
            </Link>
          ))}
        </div>
      )}
    </>
  )
}

export default RelatedNews
